/************************************************************
 Appointment Namespace
 ************************************************************/

 window.appointmentNS = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        //debug.log('appointmentNS');
        debug.log('appointmentNS, action:', action);
        /*debug.log('appointmentNS, row:', row);
        debug.log('appointmentNS, callback:', callback);*/

        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);
        this._action = action;
        this._callback = callback;
        this._row = row;


        // Cancel
        if (actionId == 3) {
            appointmentNS.openCancelAppointmentModal();
        }
        // Reschedule
        else if (( (wfId == 1 || wfId == 2 || wfId == 38) && (actionId == 2 || actionId == 17) )
            || ( wfId == 2 && (actionId == 24 || actionId == 109 || actionId == 110) )
            || ( wfId == 44 && (actionId == 24 || actionId == 109 || actionId == 110) )
            ) {

            episode.executeAction(appointmentNS._action, appointmentNS._row, appointmentNS._callback);
        } else if (actionId == 15 || actionId == 74) {
            appointmentNS.openPatientAbsence(appointmentNS.setPatientAbsenceModalHandler)
        } else if ((actionId == 17 && wfId == 8)  || (actionId == 2 && wfId == 8)) {
            physiotherapy.executeAction(appointmentNS._action, appointmentNS._row, appointmentNS._callback);
        } else if (wfId == 2 && actionId == 16) {
            physiotherapy.executeAction(appointmentNS._action, appointmentNS._row, appointmentNS._callback);
        } else if (wfId == 8 && actionId == 16) {
            physiotherapy.executeAction(appointmentNS._action, appointmentNS._row, appointmentNS._callback);
        }
        // Print Marking Consult
        else if(actionId == 23 && wfId == 1){

            var url = "/appointments/marking_consult_sheet?patient_id="+row.patient_id+"&task_id="+action.task_id;

            Hades.showDocument(url);
            appointmentNS._callback(true, appointmentNS._action, appointmentNS._row);
        }
        //Print Ticket
        else if ( actionId == 37 && wfId == 1) {

            action.data = "6" ;
            Hades.getPatientActionReport(action);

        }
        // Print Marking Consult Change
        else if(actionId == 24 && wfId == 1 ){

            var url = "/appointments/marking_consult_change_sheet?patient_id="+row.patient_id+"&task_id="+action.task_id;

            Hades.showDocument(url);

            appointmentNS._callback(true, appointmentNS._action, appointmentNS._row);

        } else if (wfId == 1 && actionId == 1 &&
                (
                    (appointmentNS._action.params && appointmentNS._action.params.treatment_type_id == globalConstants.TREATMENT_TYPE_MCDT && appointmentNS._action.params.appointment_type_id == globalConstants.APPOINTMENT_TYPE_EXAM)
                    ||
                    (appointmentNS._row.treatment_type_id == globalConstants.TREATMENT_TYPE_MCDT && appointmentNS._row.appointment_type_id == globalConstants.APPOINTMENT_TYPE_EXAM)
                )
            ) {

            debug.log("mark patient arrival mcdt");
                //appointmentNS.markPatientArrival();

            mcdtNS.markPatientArrival(action, row, appointmentNS.markPatientArrival);
            //mcdtNS.editCredential(action, row, appointmentNS.markPatientArrival);

        } else if (wfId == 1 && actionId == 1) {

            appointmentNS.markPatientArrival();

        } else if (wfId == 1 && actionId == 124) {

            mcdtNS.editCredential(action, row, callback);

        } else if (wfId == 2 && actionId == 126) {
            mcdtNS.AssociatedResults(action, row, callback, JSON.parse(action.wf_action_params) );
        } else if (wfId == 1 && actionId == 16) {
            debug.log("aqui");
            physiotherapy.executeAction(action, row, callback);
        }
        // Other actions}
        else {
            appointmentNS.executeGenericAction();
        }
    },
    markPatientArrival: function () {
        appointmentNS.getPhysicalSpaceAdmission();
        appointmentNS.executeGenericAction();
    },

    getPhysicalSpaceAdmission: function () {
        var params = {
            task_id: appointmentNS._action.task_id,
            wf_id: appointmentNS._action.wf_id,
            wf_status_id: appointmentNS._action.to_state_id,
            wf_action_id: appointmentNS._action.wf_action_id
        };

        Hades.showLoading();
        
        

        $.get('/appointments/get_physical_space_admission', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (data != null && data === 'true') {
                    appointmentNS.setPhysicalSpaceAdmissionModal(params);
                    Hades.hideLoading();
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    setPhysicalSpaceAdmissionModal: function (params) {
        debug.log('setPhysicalSpaceAdmissionModal', params);
        Hades.showLoading();
        $.get('/appointments/physical_space_admission_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#physical-space-admission-modal-ct').bind('setPhysicalSpaceAdmission', appointmentNS.setPhysicalSpaceAdmission);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                $.fancybox().close();
            });
    },

    setPhysicalSpaceAdmission: function (event, data) {
        debug.log('setPhysicalSpaceAdmission - NOT IMPLEMENTED', event, data);
        Hades.hideLoading();
        $.fancybox.close();
        
        debug.log('setPhysicalSpaceAdmission - NOT IMPLEMENTED', event, data);
        
        $.post('/appointments/set_physical_space_to_appointment', data, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                } else {
                    debug.log('setPhysicalSpaceAdmission: ', appointmentNS._callback);
                    appointmentNS._callback(true, appointmentNS._action, appointmentNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    //Patient Absence
    openPatientAbsence: function (callback) {
        var params = {
            task_id: appointmentNS._action.task_id,
            wf_id: appointmentNS._action.wf_id,
            wf_status_id: appointmentNS._action.to_state_id,
            wf_action_id: appointmentNS._action.wf_action_id
        };
        Hades.showLoading();
        $.get('/appointments/patient_absence_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                
                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#patient-absence-modal-ct').bind('patientAbsenceConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapy._callback(false, physiotherapy._action, physiotherapy._row);
            });
    },

    setPatientAbsenceModalHandler: function (event, data) {
        Hades.hideLoading();
        $.fancybox.close();
        debug.log('Appointment NS data -', data);
        appointmentNS._action.to_state_id = data.state_id;
        appointmentNS._callback(true, appointmentNS._action, appointmentNS._row);
    },
    openCancelAppointmentModal: function(){
        Hades.showLoading();

        var params = {
            task_id:this._action.task_id,
            wf_id:this._action.wf_id,
            wf_status_id:this._action.to_state_id,
            wf_action_id:this._action.wf_action_id};


        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', appointmentNS.cancelAppointment);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                appointmentNS._callback(false, appointmentNS._action, appointmentNS._row);
            });
    },
    cancelAppointment: function (event, data) {
        $.fancybox.close(true);

        debug.log('cancelAppointment',data)
        var params = {
            task_id:appointmentNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:appointmentNS._row.wf_id,
            wf_status_id:appointmentNS._row.wf_status_id,
            wf_action_id:data.actionId
        };

        debug.log('cancelAppointmentParams',params)
        $.post('/episode/cancel_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                    Hades.hideLoading();
                    appointmentNS._callback(false, appointmentNS._action, appointmentNS._row);
                } else {
                    // Data integration
                    integrationsNS.integrate(globalConstants.APPOINTMENT_INTEGRATION, {id: params.task_id, isCancel: true});
                    notificationNS.notification(params.task_id, globalConstants.EXTERNAL_NOTIFICATION_APPOINTMENT, {isCancel: true});
                    appointmentNS._callback(true, appointmentNS._action, appointmentNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                appointmentNS._callback(false, appointmentNS._action, appointmentNS._row);
            });
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeGenericAction(appointmentNS._action, appointmentNS._callback, appointmentNS._row);
    }

};